module.exports = __webpack_public_path__ + "img/KSC09033.859c67f3.jpg";